export class LoggedUser {
    id: number;
    login: string;
    email: string;
    mobile: string;
    firstName: string;
    lastName: string;
    customerPlanningAllowed: boolean;
    contactSharingToWorkerAllowed: boolean;
    hierarchicalNature: string;    
    pbiEmbedAllowed: boolean;
    photoGalleryView: string;
    photoGalleryBulkDownloadAllowed: boolean;
    
    static FromJson(json: any): LoggedUser {
        let cu = new LoggedUser();
        cu.id = json['id'];
        cu.login = json['login'];
        cu.email = json['contactEmail'];
        cu.mobile = json['contactMobile'];
        cu.firstName = json['contactFirstName'];
        cu.lastName = json['contactLastName'];
        cu.customerPlanningAllowed = json['customerPlanningAllowed'];
        cu.contactSharingToWorkerAllowed = json['contactSharingToWorkerAllowed'];
        cu.hierarchicalNature = json['hierarchicalNature'];
        cu.pbiEmbedAllowed = json['pbiEmbedAllowed'];
        cu.photoGalleryView = json['photoGalleryView'];
        cu.photoGalleryBulkDownloadAllowed = json['photoGalleryBulkDownloadAllowed'];
        return cu;
    }
    
    fullName(): string {
        let v = [];
        if (this.firstName != null) v.push(this.firstName);      
        if (this.lastName != null) v.push(this.lastName);    
        if(v.length === 0) v.push(this.login);
        return v.join(' ');
      }
}
